import { FormattedMessage } from 'react-intl';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import TRToast from '../../../_shared/helpers/TRToast';
import ConfirmModal from '../../../_shared/components/ConfirmModal';
import TradeListService from '../../../services/TradeListService';
import { removePendingTrade } from '../../../redux/slices/pending';
import Alert from '../../../_shared/components/Alert';
import { TradeState } from '../../../_shared/types/trade';
import MixpanelConfig from '../../../_shared/constants/mixpanelConfig';
import { BidSource } from '../../../_shared/types/auction';
import ROUTES from '../../Routes/constants';
import useAnalytics, {
  getSellerProperties,
  getVinBasicProperties
} from '../../../_shared/hooks/useAnalytics';
import SegmentConfig from '../../../_shared/constants/segmentConfig';

const propTypes = {
  trade: PropTypes.shape({
    id: PropTypes.number,
    auctionId: PropTypes.number
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  Button: PropTypes.func
};
const defaultProps = {
  Button: null
};

const SendToLostContainer = ({
  trade,
  isOpen,
  onClose,
  Button,
  markLostMessage
}) => {
  const track = useAnalytics();
  const tradeListService = TradeListService.get();
  const eventSource = window.location.href.includes(ROUTES.TRADE_URI)
    ? BidSource.VDP_OVERLAY
    : BidSource.LIST_VIEW;
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const handleMarkLost = async () => {
    setIsLoading(true);
    const markLost = await tradeListService.moveToTradeState(
      trade?.id,
      TradeState.pending,
      TradeState.lost
    );
    if (!markLost.isError) {
      TRToast(
        <Alert
          variant="success"
          messages={[
            <FormattedMessage id="list.modal.pending.moveToLost.confirm.success" />
          ]}
        />
      );

      track(SegmentConfig.names.pendingSendToNotSoldConfirmed, {
        ...getVinBasicProperties(trade),
        ...getSellerProperties(trade),
        event_state_type: SegmentConfig.eventStateType.sellPending
      });

      track(MixpanelConfig.names.sendToLostFromPendingConfirm, {
        source: eventSource,
        trade_id: trade?.id,
        auction_id: trade?.auctionId
      });

      const isVdp = window.location.pathname.startsWith(ROUTES.TRADE_URI);

      if (isVdp) {
        setTimeout(() => window.location.reload(), 1000);
      } else {
        dispatch(removePendingTrade(trade?.id));
      }
    } else {
      TRToast(
        <Alert
          variant="error"
          messages={[
            <FormattedMessage id="list.modal.pending.moveToLost.confirm.error" />
          ]}
        />
      );
    }
    setIsLoading(false);
  };

  const lostModalLogic = [
    {
      msg: markLostMessage || (
        <FormattedMessage id="list.modal.pending.moveToLost.confirm.message" />
      ),
      title: (
        <FormattedMessage id="list.modal.pending.moveToLost.confirm.title" />
      ),
      confirmLabel: (
        <FormattedMessage id="list.modal.pending.moveToLost.confirm.confirm" />
      ),
      cancelLabel: <FormattedMessage id="modal.cancel" />,
      onCancel: () => () => {
        onClose();
      },
      onConfirm: () => async () => {
        await handleMarkLost();
      }
    }
  ];

  return (
    <>
      {Button && <Button onClick={handleMarkLost} />}
      <ConfirmModal
        modalLogic={lostModalLogic}
        isOpen={isOpen}
        isLoading={isLoading}
        loadingMsg={<FormattedMessage id="modal.confirmation.loading" />}
      />
    </>
  );
};

SendToLostContainer.propTypes = propTypes;
SendToLostContainer.defaultProps = defaultProps;

export default SendToLostContainer;
